import { PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateChildFn, Router } from '@angular/router';
import { User } from '../interfaces/auth/auth.interfaces';
import { SUPERVISOR_TYPE } from '../services/users/user-types';

const SUPERVISOR_HOME = '/admin/operational-map';

/**
 * Mantiene al supervisor dentro del mapa operativo, su único módulo web.
 *
 * @param _route Ruta hija solicitada.
 * @param state Estado del router con la URL de destino.
 * @returns `true` si puede continuar, o la URL del mapa si debe redirigirse.
 */
export const supervisorGuard: CanActivateChildFn = (_route, state) => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }

  const userString = localStorage.getItem('USER');
  const user = userString ? (JSON.parse(userString) as User) : null;

  if (user?.type !== SUPERVISOR_TYPE || state.url.startsWith(SUPERVISOR_HOME)) {
    return true;
  }

  return inject(Router).parseUrl(SUPERVISOR_HOME);
};
